export const formatDate = (date) => {
  const day = date.getDate();
  const monthNames = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  // Determine ordinal suffix
  const getOrdinal = (n) => {
    if (n > 3 && n < 21) return "th"; // 11th, 12th, 13th
    switch (n % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  };

  return `${day}${getOrdinal(day)} ${month} ${year}`;
};


  // export const formatDateTime = (date) => {
  //   const day = date.getDate();
  //   const monthNames = [
  //     "January", "February", "March", "April", "May", "June",
  //     "July", "August", "September", "October", "November", "December"
  //   ];
  //   const month = monthNames[date.getMonth()];
  //   const year = date.getFullYear();

  //   let hours = date.getHours();
  //   const minutes = date.getMinutes().toString().padStart(2, '0');
  //   const ampm = hours >= 12 ? 'PM' : 'AM';
  //   hours = hours % 12 || 12;

  //   return `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
  // };

 
  export const formatDateTime = (date) => {
  if (!date || isNaN(date.getTime())) return "-";

  const day = date.getDate();
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  return `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
};

export const formatDateTimeSystemRelated = (date) => {
  if (!date || isNaN(date.getTime())) return "-";

  return date.toLocaleString("en-GB", {
    timeZone: "Asia/Kolkata",
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true
  });
};


export const parseBackendDate = (dateStr) => {
    if (!dateStr) return new Date();

    // "18/12/2025 10:27:04"
    const [datePart, timePart] = dateStr.split(" ");
    const [day, month, year] = datePart.split("/").map(Number);
    const [hours, minutes, seconds] = timePart.split(":").map(Number);

    return new Date(year, month - 1, day, hours, minutes, seconds);
};
// export const parseBackendDateContest = (dateStr) => {
//   if (!dateStr) return null;

//   // ISO format (2026-01-10T13:23:51.795555+05:30)
//   if (dateStr.includes("T")) {
//     const d = new Date(dateStr);
//     return isNaN(d.getTime()) ? null : d;
//   }

//   // DD/MM/YYYY HH:mm:ss
//   const [datePart, timePart = "00:00:00"] = dateStr.split(" ");
//   if (!datePart) return null;

//   const [day, month, year] = datePart.split("/").map(Number);
//   const [hours, minutes, seconds] = timePart.split(":").map(Number);

//   const d = new Date(year, month - 1, day, hours, minutes, seconds);
//   return isNaN(d.getTime()) ? null : d;
// };

export const parseBackendDateContest = (dateStr) => {
  if (!dateStr) return null;

  // ISO format
  if (dateStr.includes("T")) {
    const d = new Date(dateStr);
    return isNaN(d.getTime()) ? null : d;
  }

  // YYYY-MM-DD HH:mm:ss  ✅ BACKEND FORMAT
  if (dateStr.includes("-")) {
    const [datePart, timePart = "00:00:00"] = dateStr.split(" ");
    const [year, month, day] = datePart.split("-").map(Number);
    const [hours, minutes, seconds] = timePart.split(":").map(Number);

    const d = new Date(year, month - 1, day, hours, minutes, seconds);
    return isNaN(d.getTime()) ? null : d;
  }

  return null;
};


 

export const getIssuedAdmitCardDate = (issuedAt) => {
  return parseBackendDateContest(issuedAt);
};



export const formatAdmitCardDateTime = (date) => {
    if (!date || isNaN(date.getTime())) return "-";

    const day = String(date.toLocaleString("en-GB", { timeZone: "Asia/Kolkata", day: "2-digit" })).padStart(2, "0");
    const month = String(date.toLocaleString("en-GB", { timeZone: "Asia/Kolkata", month: "2-digit" })).padStart(2, "0");
    const year = date.toLocaleString("en-GB", { timeZone: "Asia/Kolkata", year: "numeric" });

    const timePart = date.toLocaleTimeString("en-GB", {
        timeZone: "Asia/Kolkata",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
    });

    return `${day}-${month}-${year} ${timePart}`;
};



export const getAdmitCardDate = (issuedAt, createdAt) => {
    return (
        parseBackendDateContest(issuedAt) ||
        parseBackendDateContest(createdAt) ||
        new Date()
    );
};



export const formatDateDDMMYYYY = (dateInput) => {
  const date = new Date(dateInput);  
  if (isNaN(date)) return ''; 

  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
};


export const formatDateDDMMYYYYByString = (dateString) => {
  if (!dateString) return "-";

  // Split "11-09-2025 14:37:40"
  const [datePart] = dateString.split(" "); 
  const [day, month, year] = datePart.split("-");

  return `${day}-${month}-${year}`; // dd-MM-yyyy
};

export const formatDateDDMMYYYYHHMMSS = (dateInput) => {
  if (!dateInput) return "";

  const date = new Date(dateInput);

  // Use UTC getters to avoid timezone shift
  const dd = String(date.getUTCDate()).padStart(2, '0');
  const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
  const yyyy = date.getUTCFullYear();

  const hh = String(date.getUTCHours()).padStart(2, '0');
  const min = String(date.getUTCMinutes()).padStart(2, '0');
  const sec = String(date.getUTCSeconds()).padStart(2, '0');

  return `${dd}-${mm}-${yyyy} ${hh}:${min}:${sec}`;
};

export const formatDateYYYYMMDD = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};


export const formatDateFeeDetailsDDMMYYYYHHMMSS = (dateInput) => {
  if (!dateInput) return "";

  // Check if the input is already in DD-MM-YYYY or DD-MM-YYYY HH:MM:SS
  const [datePart, timePart] = dateInput.split(" ");

  const [dd, mm, yyyy] = datePart.split("-");
  if (!dd || !mm || !yyyy) return "";

  // If time exists and is not "00:00:00", include it
  const showTime = timePart && timePart !== "00:00:00";

  return showTime ? `${dd}-${mm}-${yyyy} ${timePart}` : `${dd}-${mm}-${yyyy}`;
};


 
// Helper: parse your DD-MM-YYYY HH:MM:SS into a JS Date
export const parseDDMMYYYYHHMMSS = (dateInput) => {
  if (!dateInput) return new Date(0);

  const [datePart, timePart] = dateInput.split(" ");
  const [dd, mm, yyyy] = datePart.split("-").map(Number);
  const [hh, min, ss] = timePart ? timePart.split(":").map(Number) : [0, 0, 0];

  return new Date(yyyy, mm - 1, dd, hh, min, ss);
};


export const formatDateDDMMYYYYHHMMSS_UTC = (dateInput) => {
  if (!dateInput) return '-';

  let date;
  
  // If string is ISO
  if (/^\d{4}-\d{2}-\d{2}T/.test(dateInput)) {
    date = new Date(dateInput);
  } else {
    // Assume DD-MM-YYYY HH:MM:SS and split manually
    const [datePart, timePart] = dateInput.split(' ');
    if (!datePart || !timePart) return '-';

    const [dd, mm, yyyy] = datePart.split('-').map(Number);
    const [hh, min, sec] = timePart.split(':').map(Number);
    date = new Date(yyyy, mm - 1, dd, hh, min, sec);
  }

  if (isNaN(date)) return '-';

  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  const hh = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  const sec = String(date.getSeconds()).padStart(2, '0');

  return `${dd}-${mm}-${yyyy} ${hh}:${min}:${sec}`;
};



export const formatLocalDate = (date) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};



// utils/date.js
export const formatDateLong = (dateString) => {
  if (!dateString) return 'N/A';
  
  const date = new Date(dateString);
  if (isNaN(date)) return 'N/A';

  const options = { day: '2-digit', month: 'long', year: 'numeric' };
  return date.toLocaleDateString('en-GB', options); // e.g., "22 August 2022"
};
